<template>
  <v-data-table
    :headers="headers"
    :items="filteredItems"
    sort-desc
    item-key="system_id"
    calculate-widths
    class="gamesystem-dt"
    height="calc(100vh - 96px)"
    fixed-header
    :loading="loading"
    :footer-props="{'items-per-page-options': [25, 50, 100, -1]}"
    :items-per-page="50"
  >

    <template v-slot:top>
      <update-form v-model="dialog" :item="item" :refresh="load" />
    </template>

    <template v-slot:footer.page-text="{ pageStart , pageStop , itemsLength }">
      {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
      <v-btn @click="load" icon style="margin-right: -35px;">
        <v-icon>refresh</v-icon>
      </v-btn>
    </template>

    <template v-slot:body.prepend>
      <tr v-if="Object.keys(filters).length > 0" class="gamesystem-dt-filter-row v-data-table-header grey lighten-3">
        <td
          v-for="header in headers"
          :key="header.text"
        >
          <v-select
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
            hide-details
            dense
            small
            multiple
            clearable
            persistent-hint
            single-line
            class="gamesystem-filter-select mt-0"
            :items="filters[header.value].values || columnValueList(header.value)"
            :style="{width: (filters[header.value] || {width: false}).width}"
            v-model="filters[header.value].data"
          ></v-select>
          <v-text-field
            dense
            class="gamesystem-filter-textfield mt-0"
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
            v-model="filters[header.value].data"
            :style="{width: (filters[header.value] || {width: false}).width}"
            hide-details
          ></v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:item.action="{ item }">
      <div style="width: 50px" class="float-right">
        <v-icon small @click="edit(item)">mdi-cog-outline</v-icon>
      </div>
    </template>

    <template v-slot:item.row_num="{ item }">
      <span class="row_num"></span>
    </template>

    <template v-slot:item.name="{ item }">

      {{ item.name }}
    </template>

    <template v-slot:item.alias="{ item }">
      {{ item.alias }}
    </template>

    <template v-slot:item.enabled="{ item }">
      <v-switch
        class="ma-0 pa-0 checkbox-item-enabled"
        :label="item.enabled ? 'Enabled' : 'Disabled'"
        v-model="item.enabled"
        hide-details
        readonly
        disabled
        dense
      />
    </template>

  </v-data-table>
</template>

<style>

  .gamesystem-dt-filter-row .gamesystem-filter-textfield {
    padding-top: 6px;
  }

  .gamesystem-dt .v-btn-toggle .v-btn {
    min-height: 36px !important;
    height: 36px !important;
  }

  .gamesystem-dt-filter-row .v-input,
  .gamesystem-dt .gamesystem-filter-textfield {
    font-size: 0.875rem;
  }

  .gamesystem-dt-filter-row td {
    height: 33px !important;
  }

  .gamesystem-dt tr:not(.gamesystem-dt-filter-row) {
    counter-increment: row-num;
  }

  .gamesystem-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .gamesystem-dt .v-data-footer__select .v-select {
    margin: 5px 0 10px 34px;
  }

  .gamesystem-dt .checkbox-item-enabled .v-icon {
    margin-right: 4px;
  }

  .gamesystem-dt .v-data-footer {
    justify-content: center;
  }
</style>

<script>
  import { debounce, filter, get, isArray, toString, sortBy, cloneDeep, map, clone, toArray, omit } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    components: {
      UpdateForm: () => import('@/components/settings/gamesystem/UpdateForm'),
    },

    data: () => ({
      saveMenu: false,
      dialog: false,
      newItem: {
        settings: {}
      },
      item: {},
      selected: [],
      loading: false,
      filters: {
        alias: { data: [], type: 'text' },
        name: { data: [], type: 'text' },
        enabled: { values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ], data: [], type: 'select', width: '130px' },
      },
      filtersD: {},
      headers: [
        // { text: '#', value: 'row_num', sortable: false },
        { text: 'ID', value: 'system_id' },
        { text: 'Name', value: 'name' },
        { text: 'Alias', value: 'alias' },
        { text: 'Enabled', value: 'enabled' },
        { text: '', value: 'action', sortable: false },
      ],
      items: []
    }),

    mounted () {
      this.load()
    },

    watch: {
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    computed: {
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    methods: {
      map,
      isArray,

      keys (obj) {
        if (!obj) return {}
        return Object.keys(obj)
      },

      columnValueList (val) {
        return sortBy(filter(this.items.map(d => get(d, val)), (i) => i))
      },

      currencyConvertObj2Arr (o) {
        let out = []
        for (let k in o) {
          out.push(k + ' -> ' + o[k])
        }

        return out
      },
      edit (item) {
        this.dialog = true
        this.item = cloneDeep(item)
      },

      load () {
        this.loading = true
        return API.call('/settings/gamesystem/list.json', {}).then(resp => {
          this.selected = []
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      }
    },

  }
</script>

